module.exports = __webpack_public_path__ + "img/profile.bc1898bf.webp";